import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { fetchInquiryDetail } from '../../../api/inquiry';

const fakeData = {
  id: 1,
  carNo: '123가 1234',
  phoneNo: '010-1111-2222',
  date: '2024-01-01',
  contentTitle: '비밀번호 찾기 실패',
  content:
    '입력한 내용이 정확한데, 유효하지 않은 아이디로가 계속 나옵니다. 어떻게 해야하나요?',
  answer:
    '입력하신 내용이 정확한지 다시 한번 확인 부탁드리며, 증상이 계속되는 경우 아래 번호로 연락 바랍니다.',
};

interface InquiryDetailDtoRx {
  passid: string;
  phone: string;
  createdAt: string;
  title: string;
  question: string;
  answer: string;
}

const InquiryDetail = () => {
  const { id } = useParams<{ id: string }>();

  const [detailData, setDetailData] = useState<InquiryDetailDtoRx>();
  const history = useHistory();
  const clickHandler = () => {
    history.push(`/inquiry/update/${id}`);
  };

  // 데이터 가져오기
  useEffect(() => {
    const getInquiryDetail = async () => {
      try {
        const response = await fetchInquiryDetail(Number(id));

        setDetailData(response);
        console.log(response);
      } catch (error) {
        console.error('Error fetching order detail:', error);
      }
    };

    getInquiryDetail();
  }, [id]);

  return (
    <Container>
      <div className="content-title">
        {detailData?.title} <span>{detailData?.title}</span>
      </div>
      <div className="info">
        <ul>
          <li>
            <div className="label">차량 번호</div>
            <div className="value">{detailData?.passid}</div>
          </li>
          <li>
            <div className="label">휴대폰 번호</div>
            <div className="value">{detailData?.phone}</div>
          </li>
        </ul>
      </div>
      <div className="contents">
        <div className="title">문의 내용</div>
        <div className="text-box">{detailData?.question}</div>
      </div>
      {detailData?.answer ? (
        <div className="answer-contents">
          <div className="title">답변 내용</div>
          <div className="text-box">{detailData.answer}</div>
        </div>
      ) : null}
      {detailData?.answer ? null : <Btn onClick={clickHandler}>수정 하기</Btn>}
    </Container>
  );
};

export default InquiryDetail;

//style
const Container = styled.div`
  padding: 0 1.5rem;
  .content-title {
    margin-top: 2.4rem;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    font-size: 2rem;
    font-weight: 600;
    span {
      font-size: 1.2rem;
      font-weight: 400;
      color: ${(props) => props.theme.textAAAColor};
    }
  }
  .info {
    margin-top: 2.4rem;
    padding: 1.6rem 2.4rem;
    border-radius: 1.6rem;
    box-shadow: 0 2px 5px 3px rgba(0, 0, 0, 0.05);
    position: relative;
    ul {
      display: flex;
      flex-direction: column;
      gap: 1.2rem;
      li {
        display: flex;
        gap: 2.4rem;
        align-items: center;
        .label {
          min-width: 5.6rem;
          font-size: 1.2rem;
          font-weight: 600;
          color: ${(props) => props.theme.textAAAColor};
          line-height: 1.6rem;
        }
        .value {
          font-size: 1.4rem;
          font-weight: 600;
          &.status {
            min-width: 4.2rem;
            color: ${(props) => props.theme.textWhiteColor};
            background-color: ${(props) => props.theme.btnBlueColor};
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0.4rem;
            font-size: 1.1rem;
            border-radius: 1.1rem;
          }
        }
      }
    }
  }
  .contents {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 2.4rem;
    .title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .text-box {
      flex: 1;
      overflow: hidden;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 1.4;
      white-space: pre-line;
    }
  }
  .answer-contents {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-top: 4rem;
    .title {
      font-size: 1.5rem;
      font-weight: 600;
    }
    .text-box {
      padding: 1.9rem 1.6rem;
      min-height: 10rem;
      background-color: ${(props) => props.theme.costBgColor};
      border-radius: 1.6rem;
      flex: 1;
      overflow: hidden;
      font-size: 1.4rem;
      font-weight: 400;
      line-height: 1.4;
      white-space: pre-line;
    }
  }
`;

const Btn = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 9.4rem;
  border: none;
  outline: none;
  padding: 1.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${(props) => props.theme.btnStrongBlueColor};
  color: ${(props) => props.theme.textWhiteColor};
  font-size: 1.8rem;
  font-weight: 600;
`;
